import {useMemo} from 'react';
import {useIntl} from 'react-intl';
import {createSearchParams, useNavigate, useSearchParams} from 'react-router-dom';
import {ColumnDef} from '@tanstack/react-table';
import {PageTitle} from '../../../_metronic/layout/core';
import TableMetronic from '../../../app/common/components/table/TableMetronic';
import {PacketPowerCable} from '../Types/service';
import {useGetPacketPowerCables} from '../Hooks/PacketPowerManager';

const BaieDetailsPage = (): JSX.Element => {
  const intl = useIntl();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const serviceId = Number(searchParams.get('serviceId') ?? 0);

  const {isLoading, data: cables} = useGetPacketPowerCables(serviceId);

  const goToCable = (cable: string) => {
    const params = new URLSearchParams();
    params.append('serviceId', serviceId.toString());
    params.append('cable', cable);
    navigate({
      pathname: '/services/baies/details/cable',
      search: createSearchParams(params).toString(),
    });
  };

  const renderMobileCard = (cable: PacketPowerCable): JSX.Element => (
    <div className="d-flex align-items-center justify-content-between gap-2">
      <div className="d-flex flex-column" style={{minWidth: 0}}>
        <span className="fw-bold text-truncate">{cable.name}</span>
        <span className="text-muted">{cable.type}</span>
      </div>
      <i className="bi bi-chevron-right text-muted flex-shrink-0" />
    </div>
  );

  const columns = useMemo<ColumnDef<PacketPowerCable>[]>(
    () => [
      {
        header: intl.formatMessage({id: 'BAIE.DETAILS.COL.CABLE'}),
        accessorKey: 'name',
      },
      {
        header: intl.formatMessage({id: 'BAIE.DETAILS.COL.TYPE'}),
        accessorKey: 'type',
      },
      {
        header: '',
        id: 'detailArrow',
        size: 40,
        enableSorting: false,
        cell: () => (
          <div className="d-flex align-items-center justify-content-end pe-3">
            <i className="bi bi-chevron-right text-muted" />
          </div>
        ),
      },
    ],
    [intl]
  );

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'BAIE.DETAILS.TITLE'})}</PageTitle>

      <p>{intl.formatMessage({id: 'BAIE.DETAILS.DESCRIPTION'})}</p>

      <TableMetronic<PacketPowerCable>
        title={intl.formatMessage({id: 'BAIE.DETAILS.SUBTITLE'}, {serviceId})}
        data={cables ?? []}
        columns={columns}
        renderMobileCard={renderMobileCard}
        isLoading={isLoading}
        rowClickable={() => true}
        onRowClick={(row) => goToCable(row.name)}
      />
    </>
  );
};

export default BaieDetailsPage;
